export const authRequested = () => {
  return { type: 'auth/REQUEST_STARTED' };
}

export const authRequestCompleted = () => {
  return { type: 'auth/REQUEST_COMPLETED' };
}

export const authStatusReceived = (user) => {
  return {
    payload: { user },
    type: 'auth/STATUS_RECEIVED'
  };
}

export const authError = (errorMessage) => {
  return {
    payload: { errorMessage },
    type: 'auth/ERROR'
  };
}

export const authLoggedOut = () => {
  return {
    type: 'auth/LOGGED_OUT'
  };
}



// WEBPACK FOOTER //
// ./client/RLX/State/Auth/AuthCreators.js